export const FetchInfo = (method, body, authorization) => ({
  method: method,
  mode: 'cors',
  body: JSON.stringify(body),
  headers: {
    'Content-Type': 'application/json',
    Authorization: authorization,
  },
});
